<nav class="head-nav">
  <div class="nav-container">
    <div>
      <h2>{{ "content2.Floors" | translate }}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="restaurantId">
          <a class="breadcrumb-restaurant-name"
            [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
        </li>
        <li class="breadcrumb-item">{{"restaurant.Floors & Kitchens" | translate}}</li>
        <li class="breadcrumb-item">{{ "content2.Floors" | translate }}</li>
      </ol>
    </div>

    <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData()"></app-restaurants-dropdown>
  </div>
</nav>
<div class="page">
  <div class="page-filters" [hidden]="dataLoading">
    <div class="sort-item">
      <span class="count-page font-16">
        <span>{{recordsData?.totalCount}}</span>
        {{'content2.Floors' | translate}}
      </span>
    </div>

    <div class="filters-container">
      <div class="create-item">
        <a class="btn-light" mat-stroked-button (click)="openForm()" *ngIf="recordsData?.canAdd && restaurantId">
          <img src="./assets/images/icons/plus-ic.svg">
          <span>{{"content2.Add Floor" | translate}}</span>
        </a>
      </div>
    </div>
  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf='!dataLoading'>
    <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">
      <div class="table-responsive table-container">
        <table class="table table-primary">
          <thead>
            <tr>
              <th>{{'content2.Floor Name' | translate}}</th>
              <th>{{'content2.Number of Tables' | translate}}</th>
              <th>{{'content2.Total Covers (Seats)' | translate}}</th>
              <th>{{'content2.Available Table Online' | translate}}</th>
              <th>{{'content4.Covers Online' | translate}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of recordsData?.pageData">
              <td><a class="linkable" routerLink="/admin/floorPlan" [queryParams]="{ id: item.id }">{{item.name}}</a>
              </td>
              <td>{{item.numberOfTable}}</td>
              <td>{{item.totalCovers}}</td>
              <td>{{item.availableTableOnline}}</td>
              <td>{{item.coversOnline}}</td>
              <td>
                <div class="btn-actions">

                  <button type="button" mat-icon-button (click)="changeStatus(false, item.id)"
                    *ngIf="item.canEdit && item.isActive" [matTooltip]="'general.Deactivate' | translate">
                    <span class="material-icons activate">
                      toggle_on
                    </span>
                  </button>
                  <button type="button" mat-icon-button *ngIf="item.canEdit && !item.isActive"
                    (click)="changeStatus(true, item.id)" [matTooltip]="'general.Activate' | translate">
                    <span class="material-icons deactivate">
                      toggle_off
                    </span>
                  </button>

                  <a routerLink="/admin/floorPlan" [queryParams]="{ id: item.id }" mat-icon-button
                    [matTooltip]="'general.View' | translate">
                    <mat-icon>remove_red_eye</mat-icon>
                  </a>
                  <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                    (click)="openForm(item)" *ngIf="item.canEdit">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                    (click)="deleteRecord(item.id)" *ngIf="item.canDelete">
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>

                </div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
        <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
          [pageSizeOptions]="[5, 10, 20]" (page)="getAll($event, restaurantId)" [pageIndex]="pageIndex"></mat-paginator>
      </div>

    </div>

    <ng-template #dataEmpty>
      <empty-state [title]='"content2.No floor plans have been added yet." | translate'
        [img]="'/assets/images/icons/floors-empty.svg'"></empty-state>
    </ng-template>
  </ng-container>
</div>
